'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy(id, drugRequestId) {
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_id = null;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_drugRequestId = null;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_id = id;
  this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_drugRequestId = drugRequestId;
}
export { $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy as $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy };
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.constructor = $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy;
/** @constructor */
function $h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy() {
}
export { $h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy as $h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy };
$h_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype = $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype;
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1864079824), true);
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy)) {
    var x = this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_id;
    var x$2 = x$0.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_id;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_drugRequestId;
      var x$4 = x$0.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_drugRequestId;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.productPrefix__T = (function() {
  return "ChatsReadOfDrugRequestForPharmacy";
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_id;
  }
  if ((n === 1)) {
    return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_drugRequestId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "id";
  }
  if ((n === 1)) {
    return "drugRequestId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy.prototype.id__Ljkugiya_ulid_ULID = (function() {
  return this.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy__f_id;
});
function $isArrayOf_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy)));
}
export { $isArrayOf_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy as $isArrayOf_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy };
var $d_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy, "app.pages.AppPage$ChatsReadOfDrugRequestForPharmacy", ({
  Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy: 1,
  Lapp_pages_AppPage: 1,
  Lapp_pages_AppPage$HasChatId: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy as $d_Lapp_pages_AppPage$ChatsReadOfDrugRequestForPharmacy };
//# sourceMappingURL=app.pages.-App-Page$-Chats-Read-Of-Drug-Request-For-Pharmacy.js.map
